// extracted by mini-css-extract-plugin
export var center = "articlePage-module--center--EW-P8";
export var left = "articlePage-module--left--RIEbd";
export var mainImageContainer = "articlePage-module--mainImageContainer---8YTe";
export var premiseliftcontainer = "articlePage-module--premiseliftcontainer--7UVdM";
export var premiselifttextarea = "articlePage-module--premiselifttextarea--Cc9km";
export var premiselifttextareacontainer = "articlePage-module--premiselifttextareacontainer--K-EKn";
export var right = "articlePage-module--right--QkkBy";
export var titleContainer = "articlePage-module--titleContainer--myTwo";